import { baseApi } from 'shared/api';

type GetPDFQueryParams = {
  pathname: string;
};

export const pdfViewerApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPDF: build.query<string, GetPDFQueryParams>({
      query: ({ pathname }) => ({
        url: `${window.location.origin}${pathname}`,
        method: 'GET',
        responseHandler: (response) =>
          response.blob().then((blob) => URL.createObjectURL(blob)),
      }),
    }),
  }),
});
